import React from 'react';
import { TelephoneIncomingIcon } from 'components/atoms/icons/telephone-incoming';
import { TelephoneOutgoingIcon } from 'components/atoms/icons/telephone-outgoing';

import s from './styles.module.scss';

interface IProps {
  type: string;
}

const TypeCol: React.FC<IProps> = ({ type }) => {
  const isIncoming = type === 'INCOMING';

  return (
    <div className={s.type}>
      {isIncoming ? <TelephoneIncomingIcon /> : <TelephoneOutgoingIcon />}
    </div>
  );
};

export default TypeCol;
